import request from '@/utils/request'
import { cmsServerContext } from '@/config/config'

export function queryCustomerUserMeterInfo(meterIds, statisticsType) {
  return request({
    url: cmsServerContext + '/Meter/queryMeterWarnigRecord/' + statisticsType,
    method: 'post',
    data: meterIds
  })
}

export function queryMeterStatus(meterIds) {
  return request({
    url: cmsServerContext + '/Meter/queryMeterStatus',
    method: 'post',
    data: meterIds
  })
}

export function getCustomerAndMeter(meterId) {
  return request({
    url: cmsServerContext + '/CustomerUserMeter/getCustomerAndMeter/' + meterId,
    method: 'get'
  })
}

export function controlAvailable(condition) {
  return request({
    url: cmsServerContext + '/dasApi/controlAvailable',
    method: 'post',
    data: condition
  })
}

export function controlSwitch(condition) {
  return request({
    url: cmsServerContext + '/dasApi/controlSwitch',
    method: 'post',
    data: condition
  })
}
